import { useProvider, useIsWrongNetwork } from '@components/store/getters';
import { ethers } from 'ethers';
import Button from '../Button';
import Modal from '../Modal';
import { DescriptionText } from '../Modal/Modal.styles';
import styles from './Modal.module.css';

export default function WrongNetworkModal() {
  const provider: ethers.providers.Provider = useProvider();

  const changeToEtherum = async () => {
    //TODO: changed from send to emit, check
    provider.emit('wallet_switchEthereumChain', [{ chainId: '0x1' }]);
  };

  return (
    <>
      <DescriptionText>
        Archimedes only supports Ethereum. Change to the Ethereum Blockchain to continue.
      </DescriptionText>
      <Button onClick={changeToEtherum}>
        {/* Change to Ethereum */}
        Change to Localhost
      </Button>
    </>
  );
}
